import { baseAPI } from '~shared/api/base-api';

export interface ExportStudentListParams {
  recitalId: string;
  format?: 'csv' | 'pdf';
}

export const exportStudentList = async ({
  recitalId,
  format = 'csv',
}: ExportStudentListParams): Promise<Blob> => {
  const response = await baseAPI.get(
    `/recitals/${recitalId}/reports/students`,
    {
      params: { format },
      responseType: 'blob',
    },
  );
  return response.data;
};

export const downloadStudentList = async (
  recitalId: string,
  format: 'csv' | 'pdf' = 'csv',
): Promise<void> => {
  const blob = await exportStudentList({ recitalId, format });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `student-list-${recitalId}.${format}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
